import { Component, Inject, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TourHandler from '@/shared/tour/tour-handler';
import PersonaAccountHandler from '@/shared/persona/persona-account-handler';
import TranslationService from '@/locale/translation.service';

import EntitiesMenu from '@/entities/entities-menu.vue';

@Component({
  components: {
    'entities-menu': EntitiesMenu,
  },
})
export default class JhiNavbar extends mixins(TourHandler, PersonaAccountHandler) {
  @Inject('loginService')
  private loginService: () => LoginService;
  @Inject('translationService') private translationService: () => TranslationService;

  @Inject('accountService') private accountService: () => AccountService;

  public version = 'v' + VERSION;
  private currentLanguage = this.$store.getters.currentLanguage;
  private languages: any = this.$store.getters.languages;
  private hasAnyAuthorityValues = {};

  created() {
    const currentLanguage = Object.keys(this.languages).includes(navigator.language) ? navigator.language : this.currentLanguage;
    this.translationService().refreshTranslation(currentLanguage);
  }

  public subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input];
    return paths.some(path => {
      return this.$route.path.indexOf(path) === 0; // current path starts with this path string
    });
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  public logout(): Promise<any> {
    return this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        const next = response?.data?.logoutUrl ?? '/';
        window.location.href = next;
        if (this.$route.path !== next) {
          return this.$router.push(next);
        }
      });
  }

  public openLogin(): void {
    this.loginService().login();
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        if (this.hasAnyAuthorityValues[authorities] !== value) {
          this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
        }
      });
    return this.hasAnyAuthorityValues[authorities] ?? false;
  }

  public get openAPIEnabled(): boolean {
    return this.$store.getters.activeProfiles.indexOf('api-docs') > -1;
  }

  public get inProduction(): boolean {
    return this.$store.getters.activeProfiles.indexOf('prod') > -1;
  }

  /**
   * El método onAuthenticatedChange se ejecuta sólo cuando
   * se inicia sesión y guadar la información del usuario en
   * el store con la variable userInfo. Cuando el usuario o el
   * sistema termina con la sesión del usuario actual, en el
   * store account-store.ts durante el el metodo logout se
   * limpia la información del usuario.
   *
   * @param to
   * @param from
   */
  @Watch('authenticated')
  onAuthenticatedChange(to, from) {
    if (to) {
      this.loadPerfil();
    }
  }
}
